export default __webpack_public_path__ + "static/media/bia.fcf2bd18.png";